<template>
  <Background :bgColor="'blue'">
    <Container>
      <div class="gap-20px grid-subscribe grid">
        <div class="lg-max:hidden self-center md:w-48 lg:row-span-2">
          <img class="mx-auto md:w-48" :src="Img" alt="" />
        </div>
        <div class="md-max:flex-col gap-20px flex items-center">
          <div class="lg:hidden">
            <img class="mx-auto w-36 md:w-48" :src="Img" alt="" />
          </div>
          <div>
            <h2
              class="text-navy text-22 md:text-24 xl:text-30 mb-2 text-center md:text-left">
              Subscribe for updates
            </h2>
            <p class="text-16 md:text-18 xl:text-20 text-center md:text-left">
              Receive program news and information.
            </p>
          </div>
        </div>
        <div>
          <MarketoForm
            :mktoFormId="1951"
            :formLayout="'inline'"
            :showLegend="false"
            :hideRequired="true"
            :successMessage="{
              type: 'popup',
              message:
                'Thanks for subscribing! More news and program information to come soon.',
            }"
            smallLabel />
        </div>
      </div>
    </Container>
  </Background>
</template>

<script>
import EnvelopImg from "../../../images/illustrations/ill-envelope.svg";

import Background from "../Atoms/Background.vue";
import Container from "../Atoms/Container.vue";
import MarketoForm from "../Modules/MarketoForm.vue";

import useHasSlot from "../../compostables/useHasSlot";

export default {
  components: {
    EnvelopImg,
    Background,
    Container,
    MarketoForm,
  },

  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { slots }) {
    const { hasSlot } = useHasSlot(slots);
    const Img = EnvelopImg;

    return {
      Img,
      hasSlot,
    };
  },
};
</script>
